/*eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { useNetwork } from "../../NetworkProvider/index.jsx";

import FastAPIClient from "../../../client.js";
import config from "../../../config.js";
const client = new FastAPIClient(config);
import RecurringEventPopup from "./utils.jsx";
import { v4 as uuidv4 } from "uuid"; // Import UUID generator

import { IntlProvider } from "react-intl";

import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";
import {
    CACHE_RESPONSE_API,
    CACHE_RESPONSE_DATA,
} from "../../../sw/utils/constants.js";
import { getDataFromStore } from "../../../sw/utils/db.js";
import ActionsBar from "./ActionsBar";
import CreateEditMeetingModal from "./CreateEditMeetingModal/index";
import MeetingDetailsModal from "./MeetingDetailsModal/index";
import { existingMeetingData } from "../../../utils/Meetings/functions";

import "./styles/scrollbar.css";

const messages = {
    en: messages_en,
    fr: messages_fr,
};

const MeetingModal = ({
    isModalOpen,
    closeModal,
    initialEventData = {},
    locale,
    onCreateMeeting,
    onUpdateMeeting,
    onDeleteMeeting,
    user_id,
    detailsTrue,
    user,
    meetings,
    setSuccessMessage,
    setErrorMessage,
    attendees,
}) => {
    useEffect(() => {}, []);

    const [eventData, setEventData] = useState(
        existingMeetingData(initialEventData, detailsTrue, user)
    );

    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [typeError, setTypeError] = useState(false);
    const [clientError, setClientError] = useState(false);
    const [dateError, setDateError] = useState(false);
    const [selectedMeeting, setSelectedMeeting] = useState({
        meeting_type_id: initialEventData.meeting_type_id,
        description: "",
        is_client_meeting: false,
    });

    useEffect(() => {
        if (detailsTrue) {
            setEditMode(false);
        } else {
            setEditMode(true);
        }
    }, [detailsTrue]);

    const isUserMeetingOrganizer = initialEventData.user.user_id === user_id;

    const [clients, setClients] = useState([]);
    const [meetingTypes, setMeetingTypes] = useState([]);
    const [suggestions, setSuggestions] = useState([]); // Suggestions list
    const [selectedClient, setSelectedClient] = useState(
        initialEventData.client ? initialEventData.client.client_name : ""
    ); // Initialize with title
    const { isOnline } = useNetwork();

    const changeIsLoading = () => {
        setIsLoading(false);
    };

    useEffect(() => {
        if (user_id) {
            fetchUserClientsOnline();
        }
        changeIsLoading();
    }, [user_id]);

    useEffect(() => {
        fetchMeetingTypes();
    }, []);
    const fetchUserClientsOnline = () => {
        if (user_id != null && isOnline) {
            client.getUserClientsOnline(user_id, null).then((data) => {
                const sortedResults = data.sort((a, b) => {
                    // Move objects with 'alert' as true to the beginning
                    return b.alert - a.alert; // b.alert - a.alert will move true values to the top
                });
                setClients(sortedResults);
            });
        } else if (!isOnline) {
            fetchUserClientsOffline();
        } else {
            console.log("user_id is null or undefined, skipping API call.");
        }
    };

    const fetchUserClientsOffline = () => {
        if (user_id != null) {
            client.getUserClients(user_id, null).then((data) => {
                const sortedResults = data.sort((a, b) => {
                    // Move objects with 'alert' as true to the beginning
                    return b.alert - a.alert; // b.alert - a.alert will move true values to the top
                });
                setClients(sortedResults);
            });
        } else {
            console.log("user_id is null or undefined, skipping API call.");
        }
    };

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const fetchMeetingTypes = async () => {
        const data = await client.getMeetingTypes();
        const results = data?.data.results || [];
        if (initialEventData.client) {
            setMeetingTypes(
                results.filter((MT) => MT.is_client_meeting === true)
            );
        } else {
            setMeetingTypes(results);
        }
    };

    // const fetchMeetingTypes = async () => {
    //     const data = await client.getMeetingTypes();
    //     setMeetingTypes(data?.data.results || []);
    // };

    const getUniqueAttendees = (userId, attendeesList) => {
        // Convert to Set to remove duplicates, then back to array
        return [...new Set([userId, ...(attendeesList || [])])];
    };

    const handleSave = async (e) => {
        setIsSubmitting(true);
        e.preventDefault();
        let isValid = true;
        // let newError = null; // To track the error message

        if (eventData.meeting_type_id === "") {
            setTypeError(true);
            // newError = "report.title_required"; // Set an error key
            isValid = false;
        } else {
            setTypeError(false);
        }

        if (
            (selectedMeeting &&
                selectedMeeting.is_client_mandatory === true &&
                !eventData.client) ||
            (!eventData.client && selectedClient.length > 0)
        ) {
            setClientError(true);
            isValid = false;
        } else {
            setClientError(false);
        }

        if (!eventData.start_date || !eventData.end_date || dateError) {
            setDateError(true);
            isValid = false;
        } else {
            setDateError(false);
        }

        if (!isValid) {
            // setError(newError); // Set the error state to trigger the message display
            setIsSubmitting(false);
            return;
        }

        let offline_params = {};
        if (!isOnline) {
            const description = meetingTypes.find(
                (item) => item.meeting_type_id === eventData.meeting_type_id
            )?.description;
            const updateTimeData = detailsTrue
                ? {
                      updated_at: new Date().toISOString(),
                  }
                : {
                      created_at: new Date().toISOString(),
                      updated_at: new Date().toISOString(),
                  };
            offline_params = {
                user: {
                    user_id: user?.user_id,
                    first_name: user?.first_name,
                    last_name: user?.last_name,
                },
                type: {
                    description: description,
                },
                client: eventData.client,
                ...updateTimeData,
            };
        }
        let payload = {
            meeting_id: detailsTrue
                ? initialEventData.meeting_id
                : eventData.meeting_id,
            user: eventData.user,
            user_id: eventData.user_id,
            title:
                eventData.title === ""
                    ? selectedClient
                        ? selectedClient
                        : ""
                    : eventData.title,
            meeting_type_id: eventData.meeting_type_id,
            client_id: eventData.client ? eventData.client.client_id : null,
            start_date: eventData.start_date,
            end_date: eventData.end_date,
            is_visited: eventData.is_visited,
            attendees: getUniqueAttendees(user.user_id, eventData.attendees),
            is_recurring: eventData.is_recurring || false,
            recurring_id: eventData.recurring_id || "",
            description: eventData.description,
            lat: eventData.lat || null,
            long: eventData.long || null,
            zip_code: eventData.zip_code || null,
            address_1: eventData.address_1 || null,
            city: eventData.city || null,
            country: eventData.country || null,
            ...offline_params,
        };

        const clientObject = {
            client: eventData.client
                ? eventData.client
                : {
                      client_name: "",
                      client_id: null,
                      alert: false,
                      is_lead: false,
                  },
            ìs_organizer: true,
            is_lead: eventData.client ? eventData.client.is_lead : false,
        };
        try {
            if (detailsTrue) {
                const selectedKeys = [
                    "user",
                    "user_id",
                    "meeting_id",
                    "start_date",
                    "end_date",
                    "title",
                    "update_recurring",
                    "meeting_type_id",
                    "attendees",
                    "client",
                    "client_id",
                    "client_name",
                    "description",
                    "lat",
                    "long",
                    "address_1",
                    "zip_code",
                    "city",
                    "country",
                    "created_at",
                    "updated_at",
                ];

                const filteredPayload = selectedKeys.reduce((acc, key) => {
                    if (key in payload) {
                        acc[key] = payload[key];
                    }
                    return acc;
                }, {});
                await client.updateMeeting(
                    initialEventData.meeting_id,
                    filteredPayload
                );
                setIsSubmitting(false);
                setSuccessMessage("update.success");

                if (onUpdateMeeting) {
                    onUpdateMeeting({
                        ...filteredPayload,
                        ...clientObject,
                    });
                }
            } else {
                await client.createMeeting(payload); // Proceed with the API call
                setSuccessMessage("create.success");
                if (onCreateMeeting) {
                    onCreateMeeting({
                        ...payload,
                        ...clientObject,
                    });
                }
            }
            setIsSubmitting(false);
            closeModal();

            // alert(`Meeting successfully ${detailsTrue ? "updated" : "created"}!`);
        } catch (error) {
            // Check if the error message is "Cancelled"
            if (error === "Cancelled") {
                setIsPopupOpen(false); // Close the popup
            } else {
                setErrorMessage("submit.error"); // Set the error message
            }
            setIsSubmitting(false);
        }
    };

    const handleDelete = async () => {
        setIsSubmitting(true);
        try {
            onDeleteMeeting(
                initialEventData.meeting_id,
                initialEventData.is_recurring,
                initialEventData.recurring_id,
                initialEventData.start
            );
        } catch (error) {
            console.log(error);
            setIsSubmitting(false);
        }
        closeModal();
        setIsSubmitting(false);
    };

    const iconSize = 20;
    return (
        <IntlProvider
            locale={locale}
            defaultLocale="en"
            messages={messages[locale]}
        >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white md:rounded-2xl shadow-md md:w-1/2 w-full relative animate-slide-up h-full md:max-h-[90vh] md:h-auto flex flex-col overflow-hidden">
                    {" "}
                    <div className="w-full text-lg sticky top-0 z-10 bg-white pt-4 px-4">
                        <ActionsBar
                            closeModal={closeModal}
                            detailsTrue={detailsTrue}
                            handleDelete={handleDelete}
                            editMode={editMode}
                            setEditMode={setEditMode}
                            locale={locale}
                            isLoading={isSubmitting}
                            handleSave={handleSave}
                            is_organizer={isUserMeetingOrganizer}
                        />
                    </div>
                    <div className="overflow-y-auto px-3 md:px-8 mb-4 md:mb-1 md:scrollbar mobile-no-scrollbar flex-1">
                        {isUserMeetingOrganizer && editMode ? (
                            <CreateEditMeetingModal
                                initialEventData={initialEventData}
                                eventData={eventData}
                                setEventData={setEventData}
                                meetingTypes={meetingTypes}
                                user={user}
                                user_id={user_id}
                                detailsTrue={detailsTrue}
                                isSubmitting={isSubmitting}
                                error={error}
                                success={success}
                                iconSize={iconSize}
                                isLoading={isLoading}
                                typeError={typeError}
                                setTypeError={setTypeError}
                                dateError={dateError}
                                setDateError={setDateError}
                                clientError={clientError}
                                setClientError={setClientError}
                                clients={clients}
                                selectedClient={selectedClient}
                                setSelectedClient={setSelectedClient}
                                setSuggestions={setSuggestions}
                                handleSave={handleSave}
                                attendees={attendees}
                                selectedMeeting={selectedMeeting}
                                setSelectedMeeting={setSelectedMeeting}
                                locale={locale}
                            />
                        ) : (
                            <MeetingDetailsModal
                                eventData={eventData}
                                user_id={user_id}
                                attendees={attendees}
                                locale={locale}
                                meetingTypes={meetingTypes}
                                handleDelete={handleDelete}
                                isUserMeetingOrganizer={isUserMeetingOrganizer}
                            />
                        )}
                    </div>
                </div>
            </div>
        </IntlProvider>
    );
};

export default MeetingModal;
